export const simplifyName = (s: string) =>
  s
    .replace(/[^a-zA-Z0-9-\s]+/g, ' ') // remove all non-word except '-' and ' '
    .replace(/\s\s/g, ' ') // remove all double-spaces
    .trim(); // clean up
